import { et } from "date-fns/locale";

export type DataGridId =
  | "invoiceGrid_v1"
  | "proformaInvoiceGrid_v1"
  | "invoiceLinesCalculationGridId_v1"
  | "invoiceLinesProduktGridId_v1"
  | "invoiceSimulationDetailGridId_v1"
  | "paymentGrid_v1"
  | "requirementGrid_v1"
  | "requirementAdminGrid_v1"
  | "requirementDocumentGrid_v1"
  | "requirementReactionGrid_v1"
  | "contractGridId_v1"
  | "contractFilterGridId_v1"
  | "messagesGridId_v1"
  | "contractualAccountsGrid_v1"
  | "consumptionHistoryGrid_v1"
  | "eMobilityContractGridId_v1"
  | "contractProcessGridId_v1"
  | "depositAgreementGridId_v1"
  | "depositGridId_v1"
  | "ets2AffidavitsGridId_v1";

export const DataGridId = {
  invoiceGrid: "invoiceGrid_v1" as DataGridId,
  invoiceLinesCalculationGrid: "invoiceLinesCalculationGridId_v1" as DataGridId,
  invoiceLinesProduktGrid: "invoiceLinesProduktGridId_v1" as DataGridId,
  invoiceSimulationDetailGridId: "invoiceSimulationDetailGridId_v1" as DataGridId,
  paymentGrid: "paymentGrid_v1" as DataGridId,
  requirementGrid: "requirementGrid_v1" as DataGridId,
  requirementAdminGrid: "requirementAdminGrid_v1" as DataGridId,
  requirementDocumentGrid: "requirementDocumentGrid_v1" as DataGridId,
  requirementReactionGrid: "requirementReactionGrid_v1" as DataGridId,
  contractGrid: "contractGridId_v1" as DataGridId,
  contractFilterGrid: "contractFilterGridId_v1" as DataGridId,
  messagesGrid: "messagesGridId_v1" as DataGridId,
  contractualAccountsGrid: "contractualAccountsGrid_v1" as DataGridId,
  proformaInvoicesGrid: "proformaInvoiceGrid_v1" as DataGridId,
  consumptionHistoryGrid: "consumptionHistoryGrid_v1" as DataGridId,
  eMobilityContractGrid: "eMobilityContractGridId_v1" as DataGridId,
  contractProcessGrid: "contractProcessGridId_v1" as DataGridId,
  depositAgreementGrid: "depositAgreementGridId_v1" as DataGridId,
  ets2AffidavitsGrid: "ets2AffidavitsGridId_v1" as DataGridId,
};
